import { useEffect, useState } from "react";
import { Button, Popover, Skeleton } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { RiFullscreenExitLine, RiFullscreenLine } from "react-icons/ri";
import { Link, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import BreadcrumbCustom from "./BreadcrumbCustom";

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}>
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ onPress, data, loading, isSideNavNan }) {
  const userId = localStorage.getItem("id");
  const isLogged = localStorage.getItem("isLogged");
  const user = localStorage.getItem("user");
  const element = document.documentElement;
  const dispatch = useDispatch();
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  const [fullScreen, setFullScreen] = useState(false);
  const [imageError, setImageError] = useState();

  const handleFullScreenClick = () => {
    setFullScreen(true);
    if (element.requestFullscreen) element.requestFullscreen();
    else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
    else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
    else if (element.msRequestFullscreen) element.msRequestFullscreen();
  };

  const handleExitFullScreenClick = () => {
    setFullScreen(false);
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    else if (document.msExitFullscreen) document.msExitFullscreen();
  };

  useEffect(() => {
    const onChange = () => setFullScreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  return (
    <>
      <div className="sticky top-0 z-10 flex w-full items-center justify-between py-3 pl-3 pr-4 bg-white dark:bg-[#1C1B20] border-b">

        {/* LEFT GROUP (always first). Mobile toggle pinned to the far left */}
        <div className="flex items-center gap-4 md:gap-3">
          {isLogged && !isSideNavNan && (
            <Button
              type="link"
              className="block md:hidden -ml-2"   // nudge to screen edge
              onClick={onPress}
              style={{ boxShadow: "none" }}
            >
              {toggler}
            </Button>
          )}

          {/* Optional: show Home/Breadcrumb on larger screens */}
          {/* {isLogged && (
            <div className="hidden md:flex items-center">
              {isSideNavNan && (
                <NavLink className="mr-2 font-semibold text-blue-500" to="/admin/dashboard">
                  Home
                </NavLink>
              )}
              <BreadcrumbCustom />
            </div>
          )} */}
        </div>

        {/* RIGHT GROUP (fullscreen + user menu) */}
        <div className="flex items-center gap-2 md:gap-4">
          {isLogged && (
            fullScreen ? (
              <RiFullscreenExitLine
                onClick={handleExitFullScreenClick}
                size={22}
                className="cursor-pointer dark:text-white"
              />
            ) : (
              <RiFullscreenLine
                onClick={handleFullScreenClick}
                size={22}
                className="cursor-pointer dark:text-white"
              />
            )
          )}

          {isLogged && (
            <Popover
              placement="rightBottom"
              trigger="click"
              content={
                <div className="min-w-[150px] rounded-lg">
                  <p className="flex items-center gap-1 px-3 py-2 hover:bg-slate-200 rounded-lg">
                    <UserOutlined style={{ fontSize: 16 }} />
                    <Link
                      to={`/admin/staff/${userId}`}
                      className="logout-text uppercase font-weight-bold me-2 ms-1"
                    >
                      {user}
                    </Link>
                  </p>

                  <Link
                    to="/admin/auth/logout"
                    className="flex items-center gap-1 px-3 py-2 hover:bg-slate-200 rounded-lg"
                  >
                    <LogoutOutlined className="text-red-500" />
                    <span className="logout-text font-weight-bold">Log Out</span>
                  </Link>
                </div>
              }
              arrow={false}
            >
              <UserOutlined className="text-xl cursor-pointer dark:text-white" />
            </Popover>
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
